import {BLOCK_HISTORY, UNBLOCK_HISTORY, SET_USER, USER_IS_LOADING} from "./index";
import  { Auth } from 'aws-amplify';

import { redirectToLogIn } from '../util/util';

export function unblockNavigation() {
    return {
        type: UNBLOCK_HISTORY
    }
}

export function blockNavigation(history) {
    const unblock = history.block('You have unsaved content on this page. Are you sure you would like to leave?');
    return {
        type: BLOCK_HISTORY,
        payload: unblock
    }
}

export function userIsLoading(isLoading){
    return {
        type: USER_IS_LOADING,
        payload: isLoading
    }
}

export function recievedSetUser(user){
    return {
        type: SET_USER,
        payload: user
    }
}

export function setUser(){
    return (dispatch) => {
        dispatch(userIsLoading(true));
        return Auth.currentSession()
        .then((session) => {
            console.log("SET USER");
            dispatch(recievedSetUser(session.idToken.payload));
        })
        .catch((error) => {
            if(error === 'No current user'){
                redirectToLogIn();
            }
            console.log(error);
        }).finally( () => {
            dispatch(userIsLoading(false));
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions-app.js